import React, { useState, useEffect } from "react";
import { Delete, DoubleArrow, Edit } from "@mui/icons-material";
import { themes } from "services/constants";
import {
  CardContent,
  Box,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Paper,
  Card,
  IconButton,
  Grid,
  Stack,
} from "@mui/material";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { editIconStyle } from "services/constants";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { useForm } from "react-hook-form";
import { CustomTextBox } from "components/CustomComponents";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import sessionHandling from "services/utils/notificationUtils";
import { showToast } from "services/utils/Status";
import { customAPI } from "services/utils/CustomAPI";
import { deleteIconStyle } from "services/constants";
import { TableEmptyState } from "components/CustomComponents/EmptyState";

export const ViewShiftGroup = ({
  onClose,
  selectedItem,
  setRecallGetApi,
  setVwSftGrp,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const [shiftGrpDetails, setShiftGrpDetails] = useState("");
  const [tiggerApi, setTriggerApi] = useState(true);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      is_edit: false,
      shift_group_name: "",
    },
  });

  useEffect(() => {
    const getGroupData = async () => {
      const res = await customGetAPI(
        `${domain}administration/shiftroster/userassignment/shiftgroup/group/histroy/details/?shift_rota_id=${selectedItem?.shift_rota_id}&shift_group_id=${selectedItem?.id}&company_id=${requestCompanyId}`
      );
      if (res.ok) {
        setShiftGrpDetails(res?.responseDetails);
        setTriggerApi(false);
      } else {
        setTriggerApi(false);
      }
    };
    if (tiggerApi && selectedItem?.id && selectedItem?.shift_rota_id) {
      getGroupData();
      setTriggerApi(false);
    }
  }, [domain, tiggerApi, selectedItem?.id, selectedItem?.shift_rota_id, requestCompanyId]);

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    reset();
  };

  const onSubmit = async () => {
    setValue("button_loader", true);
    const response = await customAPI(
      `${domain}administration/shiftroster/shiftgroups/shift-groups/${selectedItem?.id}/`,
      "PUT",
      {
        primary_shift_grade: 1,
        name: !watch("is_edit")
          ? selectedItem?.name
          : watch("shift_group_name").trim(),
        ...(!watch("is_edit") && { status: "Inactive" }),
      }
    );
    if (response.ok) {
      showToast(
        !watch("is_edit") ? "error" : "success",
        !watch("is_edit")
          ? "Shift group deleted successfully"
          : "Shift group name updated successfully"
      );
      setShowConfirmationDialog(false);
      setRecallGetApi(true);
      setVwSftGrp(false);
      reset();
    } else {
      showToast("error", response?.message);
    }
  };

  const updateSftGrpName = (event) => {
    setValue("shift_group_name", event.target.value);
  };

  return (
    <React.Fragment>
      <ConfirmationDialog
        open={showConfirmationDialog}
        onClose={handleCancelClose}
        onConfirm={handleSubmit(onSubmit)}
        title={
          !watch("is_edit") ? "Delete Shift Group" : "Change Shift Group Name"
        }
        confirmText={!watch("is_edit") ? "Delete" : "Update"}
        cancelText="Cancel"
        showChildren={true}
      >
        {watch("is_edit") ? (
          <Box>
            <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontWeight: 700, minWidth: 220 }}>
                Current Shift Group Name
              </Typography>

              <Typography>:</Typography>

              <Typography sx={{ fontWeight: 700, ml: 1 }}>
                {selectedItem?.name}
              </Typography>
            </Box>

            <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontWeight: 700, minWidth: 220 }}>
                New Shift Group Name
              </Typography>

              <Typography>:</Typography>
              <Box sx={{ width: "61%", ml: 1 }}>
                <CustomTextBox
                  selectedValue={watch("shift_group_name")}
                  {...register("shift_group_name", {
                    required: "Shift group name is required",
                    minLength: {
                      value: 3,
                      message: "Minimum 3 characters are required",
                    },
                    maxLength: {
                      value: 100,
                      message: "Maximun length is 100 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                      editLeaveName: async (fieldValue) => {
                        if (fieldValue.trim() === "") {
                          return "Minimum 3 characters are required";
                        } else {
                          try {
                            const response = await fetch(
                              `${domain}unique/shift-group/?name=${fieldValue.trim()}`,
                              {
                                method: "GET",
                                headers: {
                                  "content-type": "application/json",
                                  Authorization: `token ${token}`,
                                },
                              }
                            );
                            const res = await response.json();
                            if (response.ok) {
                              if (res.exists) {
                                return "Shift group is already exists";
                              } else {
                                return true;
                              }
                            } else if (response.status === 409) {
                              sessionHandling();
                            } else {
                              throw new Error('REQUEST_FAILED');
                            }
                          } catch (error) {
                            console.error('[Viewshiftgroup] operation failed:', error);
                            showToast("error", "Couldn't save the shift assignment. Please try again.");
                          }
                        }
                      },
                    },
                  })}
                  updateDataFunction={updateSftGrpName}
                  placeHolder="Enter new shift group name"
                  errorMessage={
                    errors?.shift_group_name?.message
                      ? errors?.shift_group_name?.message
                      : ""
                  }
                  textBoxError={errors.shift_group_name ? true : false}
                />
              </Box>
            </Box>
          </Box>
        ) : (
          <Box>
            <Typography sx={{ fontWeight: 600, ml: 1 }}>
              Are you sure you want to delete{" "}
              <strong>{selectedItem?.name || "this item"}</strong>? This action
              cannot be undone.
            </Typography>
          </Box>
        )}
      </ConfirmationDialog>

      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            borderBottom: `1px solid ${themes?.miliedLightGray}`,
            borderRadius: 0,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1,
              }}
            >
              <Box sx={{ ml: 1 }}>
                <IconButton
                  onClick={onClose}
                  sx={{
                    color: themes?.grayColor,
                    "&:hover": {
                      backgroundColor: themes?.whiteColor,
                    },
                  }}
                >
                  <DoubleArrow />
                </IconButton>
              </Box>
              {!selectedItem?.shift_rota_id && (
                <Box sx={{ mr: 1 }}>
                  <IconButton
                    onClick={() => setShowConfirmationDialog(true)}
                    sx={deleteIconStyle}
                  >
                    <Delete />
                  </IconButton>
                </Box>
              )}
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {selectedItem?.name}
                </Typography>

                <IconButton
                  sx={editIconStyle}
                  onClick={() => {
                    setShowConfirmationDialog(true);
                    setValue("is_edit", true);
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                View your shift group configuration
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card
                sx={{
                  bgcolor: "#FCECF7",
                  border: `1px solid #F7B7D3`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FCECF7",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #F7B7D3`,
                      }}
                    >
                      <CalendarMonthIcon
                        sx={{ color: "#E64899", fontSize: 20 }}
                      />
                    </Box>

                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Current Shift Rota
                    </Typography>
                  </Box>

                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "20px",
                    }}
                  >
                    {selectedItem?.shift_rota_name ?? "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={12}>
              <Card
                sx={{
                  bgcolor: "#EAF2FC",
                  border: `1px solid #9FC4F7`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#EAF2FC",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #9FC4F7`,
                      }}
                    >
                      <CalendarMonthIcon
                        sx={{ color: "#1E88E5", fontSize: 20 }}
                      />
                    </Box>

                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Shift Name
                    </Typography>
                  </Box>

                  <Box sx={{ mt: 1 }}>
                    {shiftGrpDetails?.shift_rota_shifts?.map((row) => (
                      <Typography
                        variant="body1"
                        fontWeight="600"
                        color="#000"
                        sx={{
                          whiteSpace: "pre-line",
                          wordBreak: "break-word",
                          fontSize: "17px",
                        }}
                      >
                        {row?.shift_name} ({row?.shift_start_time} -{" "}
                        {row?.shift_end_time})
                      </Typography>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={12}>
              <Card
                sx={{
                  bgcolor: "#EDF8F0",
                  border: `1px solid #8AD0A0`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#EDF8F0",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #8AD0A0`,
                      }}
                    >
                      <PersonOutlineIcon
                        sx={{ color: "#2E7D32", fontSize: 20 }}
                      />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      No of Employees
                    </Typography>
                  </Box>

                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {selectedItem?.user_count}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Box sx={{ mt: 4 }}>
            <Typography fontWeight={600} sx={{ mb: 2 }}>
              Shift Rota History
            </Typography>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                    <TableCell>Shift Rota</TableCell>
                    <TableCell>Effective From</TableCell>
                    <TableCell>Effective To</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shiftGrpDetails?.length === 0 ? (
                    <TableEmptyState dataLength={shiftGrpDetails} />
                  ) : (
                    shiftGrpDetails?.shift_group_history?.map((row) => (
                      <TableRow key={row.shift_assignment_name}>
                        <TableCell>{row?.shift_assignment_name}</TableCell>
                        <TableCell>
                          {row?.effective_from ? row?.effective_from : "N/A"}
                        </TableCell>
                        <TableCell>
                          {row?.effective_to ? row?.effective_to : "N/A"}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
